import React from 'react';
import '../css/input.css';
const Box = (props) => {
    return (
        <article className={`box ${props.className ? props.className : ""}`} style={props.style}>
            {props.children}
        </article>
    );
};

export default Box;